export interface ContactPerson {
	contactPersonName: string;
	contactPersonLastName: string;
	contactPersonPosition: string;
	contactPersonEmail: string;
	contactPersonPhone: string;
}

export interface ApplicantCompanyInformation {
	applicantCompanyBusinessName: string;
	applicantCompanyName: string;
	applicantCompanyId: string;
	applicantCompanyAddress: string;
	applicantCompanyDepartment: string;
	applicantCompanyLocation: string;
	applicantCompanyPhone: string;
	applicantCompanyWeb: string;
	applicantCompanyEmail: string;
	applicantCompanyFacebook: string;
	applicantCompanyInstagram: string;
	applicantCompanyLinkedIn: string;
	applicantCompanyTwiter: string;
}

export interface LegalRepresentative {
	legalRepresentativeName: string;
	legalRepresentativeDocumentType: string;
	legalRepresentativeDocumentTypeOtherName: string;
	legalRepresentativeDocumentNumber: string;
}

export interface OrganizationSite {
	organizationSiteSubsidiaries: Array<{
		name: string;
		address: string;
		activity: string;
	}>;
}

export interface StaffHired {
	staffHiredFirstQuestion: string;
	staffHiredSecondQuestion: string;
	staffHiredThirdQuestion: string;
	staffHiredFemalePercentage: number;
	staffHiredSeniority: string;
}

export interface CommonClassification {
	commonClassification: string[];
}

export interface ExporterProfile {
	exporterProfileFirstQuestion: string;
	exporterProfileSecondQuestion: string;
	exporterProfileThirdQuestion: string;
	exporterProfileComment: string;
}

export interface ExporterProfile {
	exporterProfileFirstQuestion: string;
	exporterProfileSecondQuestion: string;
	exporterProfileThirdQuestion: string;
	exporterProfileComment: string;
}

export interface ImporterProfile {
	importerProfileValue: string;
	importerProfileComment: string;
}

export interface PerformAccountingAudits {
	accountingAuditsValue: string;
	accountingAuditsCompanyName: string;
}

export interface SustainabilityPractices {
	sustainabilityPracticesComment: string;
}

export interface FactorsHallmarks {
	factorsHallmarksComment: string;
}

export interface CompanyMemberships {
	companyMemberships: string[];
	companyMembershipsOthers: string;
}

export interface DataConfirmation {
	dataConfirmationCheck1: boolean;
	dataConfirmationCheck2: boolean;
	dataConfirmationCheck3: boolean;
}

export interface PolicyOfSustainability {
	policyOfSustainability: string;
}

export interface SustainabilityReporting {
	sustainabilityReportingValue: string;
	sustainabilityReportingComment: string;
}

export interface NormCertificate {
	id: number;
	normId: string;
}

export interface Certifications {
	certificationsNorms: NormCertificate[];
}

export interface CountryBrandApplicationAttachments {
	id: string;
	name: string;
	url: string;
	type: "BPS" | "DGI" | "PolicyOfSustainability" | "SustainabilityReporting" | `NORM_${string}`;
	file?: File;
	status: "ADD" | "EDIT" | "DELETE" | "READ";
}

export interface CountryBrandApplication
	extends ContactPerson,
		ApplicantCompanyInformation,
		LegalRepresentative,
		OrganizationSite,
		StaffHired,
		CommonClassification,
		ExporterProfile,
		ImporterProfile,
		PerformAccountingAudits,
		Certifications,
		CompanyMemberships,
		PolicyOfSustainability,
		SustainabilityPractices,
		FactorsHallmarks,
		DataConfirmation {
	id?: string;
	isCompleted: boolean;
	lastStepCompleted: number;
	uuid: string;
	attachments: CountryBrandApplicationAttachments[];
}

export function defaultCountryBrandApplication(uuid: string): CountryBrandApplication {
	return {
		isCompleted: false,
		lastStepCompleted: 0,
		uuid,
		attachments: [],
		contactPersonName: "",
		contactPersonLastName: "",
		contactPersonPosition: "",
		contactPersonEmail: "",
		contactPersonPhone: "",
		applicantCompanyBusinessName: "",
		applicantCompanyName: "",
		applicantCompanyId: "",
		applicantCompanyAddress: "",
		applicantCompanyDepartment: "",
		applicantCompanyLocation: "",
		applicantCompanyPhone: "",
		applicantCompanyWeb: "",
		applicantCompanyEmail: "",
		applicantCompanyFacebook: "",
		applicantCompanyInstagram: "",
		applicantCompanyLinkedIn: "",
		applicantCompanyTwiter: "",
		legalRepresentativeName: "",
		legalRepresentativeDocumentType: "",
		legalRepresentativeDocumentTypeOtherName: "",
		legalRepresentativeDocumentNumber: "",
		organizationSiteSubsidiaries: [],
		staffHiredFirstQuestion: "NO",
		staffHiredSecondQuestion: "NO",
		staffHiredThirdQuestion: "NO",
		staffHiredFemalePercentage: 0,
		staffHiredSeniority: "",
		commonClassification: [],
		exporterProfileFirstQuestion: "NO",
		exporterProfileSecondQuestion: "NO",
		exporterProfileThirdQuestion: "NO",
		exporterProfileComment: "",
		importerProfileValue: "SI",
		importerProfileComment: "",
		accountingAuditsValue: "",
		accountingAuditsCompanyName: "",
		sustainabilityPracticesComment: "",
		policyOfSustainability: "NO",
		factorsHallmarksComment: "",
		companyMemberships: [],
		companyMembershipsOthers: "",
		certificationsNorms: [],
		dataConfirmationCheck1: false,
		dataConfirmationCheck2: false,
		dataConfirmationCheck3: false,
		id: "-1",
	} as CountryBrandApplication;
}

export function generateUUID(length = 8): string {
	return crypto.randomUUID().substring(0, length).toUpperCase();
}
